export default __webpack_public_path__ + "static/media/lesnik_summer_02.5a702710.svg";